export const getErrorMessage = (error: any) => {
  if (!error) return 'Terjadi kesalahan, silakan coba lagi nanti'

  if (
    error.response?.data?.message &&
    typeof error.response?.data?.message === 'string'
  ) {
    return error.response?.data?.message
  } else if (
    error.errors?.message &&
    typeof error.errors?.message === 'string'
  ) {
    return error.errors?.message
  } else if (error.data?.message && typeof error.data?.message === 'string') {
    return error.data?.message
  } else if (error.data?.data && typeof error.data?.data === 'string') {
    return error.data?.data
  } else if (error.data && typeof error.data === 'string') {
    return error.data
  } else if (error.message && typeof error.message === 'string') {
    return error.message
  } else {
    return 'Terjadi kesalahan, silakan coba lagi nanti'
  }
}
